export default __webpack_public_path__ + "static/media/Presidencia.c313fb54.svg";